import React, { useCallback } from 'react';
import styled from 'styled-components';
import header_bg from 'assets/img/landing/header_bg.jpg';
import terms_logo from 'assets/img/landing/logo.svg'
import bet_logo from 'assets/img/landing/bet_logo.svg'
import { detectMob, navigateToBWWLoginScreen, User } from 'modules/utils';
import { HOCisTrue } from 'components/HOCisTrue';
import { LogosWrapper } from './styles';
import { useSelector } from 'react-redux';
import { getIsBettingAllowed } from 'modules/selectors';
import { get } from 'lodash';

const mobileBreakPoint = '1000px';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 415px;
  padding: 40px 24px 56px 24px;

  @media screen and (max-width: ${mobileBreakPoint}) {
	min-height: unset;
	padding: 20px 24px 0 24px;
  }
`

const InnerWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;

  h2 {
	color: #FFFFFF;
	font-family: Champion, sans-serif;
	font-size: 30px;
	letter-spacing: 0;
	line-height: 30px;
	margin-bottom: 24px;
	text-align: center;
  }

  h1 {
	color: #FFFFFF;
	font-family: Champion, sans-serif;
	font-size: 85px;
	letter-spacing: 0;
	line-height: 80px;
	text-align: center;
	max-width: 740px;
	font-weight: 500;
	padding-bottom: 18px;
  }

  span {
	color: #FEC600;
  }

  @media screen and (max-width: ${mobileBreakPoint}) {
	h1 {
	  font-size: 33px;
	  letter-spacing: 0;
	  line-height: 34px;
	  text-align: center;
	}

	h2 {
	  display: none;
	}

	img {
	  height: 46px;
	  margin: 0 auto 20px auto;
	  display: block;
	}
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: url(${header_bg});
  filter: brightness(15%);
  mix-blend-mode: darken;
`

const ActionsWrapper = styled.div`
  position: relative;
  padding-bottom: 20px;

  div {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 14px;
	margin-top: 12px;

	button {
	  background-color: #FEC600;
	  color: #1C1C1C;
	  font-family: Champion, sans-serif;
	  padding: 16px 12px 14px 12px;
	  text-align: center;
	  font-size: 18px;
	  letter-spacing: 0;
	  line-height: 22px;
	  border-radius: 2px;
	  border: none;
	  cursor: pointer;
	  text-transform: uppercase;
	  width: 100%;

	  &.white {
		background: #FFFFFF;
	  }
	}
  }

  p {
	color: #FFFFFF;
	font-family: Barlow, sans-serif;
	font-size: 14px;
	letter-spacing: 0;
	line-height: 16px;
	margin-bottom: 24px;
	text-align: center;
	margin-top: 16px;
	font-weight: 500;

	&.non-app {
	  margin-bottom: 0;
	}

	a {
	  text-decoration: underline;
	}
  }
`;

const MobileBet = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
	display: block;
	color: #FFFFFF;
	font-family: Barlow, sans-serif;
	font-size: 14px;
	letter-spacing: 0;
	line-height: 16px;
	margin-bottom: 8px;
	margin-top: 8px;
  }

  @media screen and (max-width: 1000px) {
	img {
	  height: 32px;
	}
  }
`

interface IProps {
	toggleGuestVisibility?: () => void;
}

export const LandingHeaderSection: React.FC<IProps> = ({toggleGuestVisibility}) => {
	const isBettingAllowed = useSelector(getIsBettingAllowed);
	const isMobile = detectMob();
	const user = User.GET_USER_OBJECT();

	const isBetLogoVisible = !isMobile && isBettingAllowed;
	const isMobileBetLogoVisible = isMobile && isBettingAllowed;

	const deviceType = get(user, 'device_type');
	const isApp = (deviceType === 'ios' || deviceType === 'android');

	const goLogin = useCallback(() => {
		if (!isApp) {
			return;
		}
		navigateToBWWLoginScreen('/account/log-in/');
	}, [isApp])

	return (
		<Wrapper>
			<Background/>
			<InnerWrapper>
				<LogosWrapper>
					<img src={terms_logo} alt="logo"/>
					<HOCisTrue when={isBetLogoVisible}>
						<div>
							<img src={bet_logo} alt="Bet logo"/>
						</div>
					</HOCisTrue>
				</LogosWrapper>
				<h2>
					WELCOME TO BUFFALO WILD WINGS GAMES
				</h2>
				<h1>
					DAILY FREE-TO-PLAY GAMES <span>FOR REAL PRIZES</span>
				</h1>
				<HOCisTrue when={isMobileBetLogoVisible}>
					<MobileBet>
						<h2>Presented by</h2>
						<img src={bet_logo} alt="Bet logo"/>
					</MobileBet>
				</HOCisTrue>
			</InnerWrapper>

			<HOCisTrue when={isMobile}>
				<ActionsWrapper>

					<HOCisTrue when={!isApp}>
						<p className="non-app">Don't have an account? Download the Blazin' Rewards App and sign-up
							today! </p>
					</HOCisTrue>
					<HOCisTrue when={isApp}>
						<p>Already have an account? Login from the home page.</p>
						<div>
							<button onClick={goLogin}>LOGIN NOW TO YOUR ACCOUNT TO PLAY</button>
						</div>
					</HOCisTrue>
				</ActionsWrapper>
			</HOCisTrue>
		</Wrapper>
	);
}
